import { drawerStore, MainButton, MobileDrawerFrame, Typography } from "@eventr/common-storybook";
import { Box } from "@mui/material";
import { FC, useMemo } from "react";
import { ItinTagsList } from "feat/components/itinTagsList";
import i18n from "i18n/i18next";
import { useBoundStore } from "state/bound.store";

type TCarouselItineraryTags = { id?: string; tags: number[] };
export const CarouselItineraryTags: FC<TCarouselItineraryTags> = ({ id, tags }) => {
  // The stored reference, not a defaulted copy: `?? []` in the selector is a new array every
  // call, which useShallow compares by identity, so the snapshot never settles. Only guests
  // reach it - their org_config carries no itinTags.
  const allTags = useBoundStore((s) => s.orgConfig?.itinTags);

  const tagObjs = useMemo(() => {
    return (allTags ?? []).filter((testTag) => {
      return tags?.includes(testTag.id);
    });
  }, [allTags, tags]);

  if (!tags) return null;

  return (
    <Box
      id={id}
      sx={{
        display: "grid",
        gridAutoFlow: "column",
        height: "6px",
        width: "max-content",
        gap: "4px",
      }}
      onClick={() => {
        drawerStore().openDrawer({
          node: (
            <MobileDrawerFrame title={i18n.t("home.itinTags")} minHeight="30vh">
              <Box
                sx={{
                  display: "grid",
                  gridTemplateRows: "auto auto 1fr auto",
                }}
              >
                <Box
                  sx={{
                    height: "16px",
                  }}
                />
                <Typography id="itinerary-tag-drawer-current-itinerary-name" variant="bodyBold" align="center">
                  {useBoundStore.getState().getEventInfoV2()?.data?.title ?? ""}
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <ItinTagsList tagIds={tags} />
                </Box>
                <MainButton
                  id="itinerary-tag-drawer-done-button"
                  variant="secondary"
                  text={i18n.t("general.done")}
                  onClick={() => {
                    drawerStore().closeDrawer();
                  }}
                />
              </Box>
            </MobileDrawerFrame>
          ),
          onBackdropClick: () => drawerStore().closeDrawer(),
        });
      }}
    >
      {tagObjs.map((tagObj) => {
        if (!tagObj || !tagObj.colour) {
          return null;
        }
        return (
          <Box
            key={tagObj.name}
            sx={{
              height: "6px",
              width: "32px",
              backgroundColor: tagObj.colour,
              borderRadius: "6px",
            }}
          />
        );
      })}
    </Box>
  );
};
